<div class="analytics-menu" *ngIf="hasAnalytics()">
  <div class="menu-header" (click)="toggleMenu()">
    <i class="bi bi-graph-up"></i>
    <span class="menu-title">Analytics</span>
    <i class="bi chevron-icon" [ngClass]="isExpanded ? 'bi-chevron-down' : 'bi-chevron-right'"></i>
  </div>

  <div class="menu-items" [class.expanded]="isExpanded">
    <div
      *ngFor="let item of menuItems; trackBy: trackById"
      class="menu-item"
      [routerLink]="[baseRoute + '/analytics', item.id]"
      routerLinkActive="active"
    >
      <i class="bi bi-bar-chart-fill"></i>
      <span>{{ item.menuName }}</span>
      <!-- Stale indicator — visible only for admins -->
      <i
        *ngIf="isAdminUser && item.status === dashboardMappingStatus.Stale"
        class="bi bi-exclamation-triangle-fill text-warning ms-auto"
        title="This dashboard may be stale"
      ></i>
    </div>
  </div>
</div>
